import { render, staticRenderFns } from "./FinishedBattles.vue?vue&type=template&id=89c6c4a6&scoped=true&"
import script from "./FinishedBattles.vue?vue&type=script&lang=ts&"
export * from "./FinishedBattles.vue?vue&type=script&lang=ts&"
import style0 from "./FinishedBattles.vue?vue&type=style&index=0&id=89c6c4a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c6c4a6",
  null
  
)

export default component.exports